namespace Matrix.Rebalancer {
    export class SummaryViewColumns {
        static columnsKey = 'Rebalancer.SummaryView';
    }
}
